export class RefreshViewModel {
    constructor(
        refresh: string,
        userId: string,
        clintId: string,
        appId?: number
    ) {
        this.appId = appId;
        this.clientId = clintId;
        this.userId = userId;
        this.refreshToken = refresh;
    }
    public appId?: number;
    public userId: string;
    public clientId: string;
    public refreshToken: string
}